/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfNavigationItemDto } from '../../models/platform-api-result-of-navigation-item-dto';
import { PlatformCreateNavigationItem } from '../../models/platform-create-navigation-item';

export interface PostNavigationitems$Params {
      body: PlatformCreateNavigationItem
}

export function postNavigationitems(http: HttpClient, rootUrl: string, params: PostNavigationitems$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, postNavigationitems.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfNavigationItemDto>;
    })
  );
}

postNavigationitems.PATH = '/api/navigationitems';
